import SwitchLocale from './switch_locale';

export default SwitchLocale;
